import { FaqProps } from "@ft/components/common/Faq";

const URLDecoderFaqData: FaqProps[] = [
  {
    question: "What is a URL decoder?",
    ans: "A URL decoder is a tool that transforms encoded URLs back into their original, readable format.",
  },
  {
    question: "How do I decode URL?",
    ans: "Paste your encoded URL into the decoder's input field. The decoded URL will appear in the output field.",
  },
  {
    question: " Is this tool free to use?",
    ans: "Absolutely! This tool is completely free to use, with no restrictions or limitations.",
  },
  {
    question: "Is online URL decoder safe?",
    ans: "Yes, The URL decoding process is 100% secure and does not store or share your information.",
  },
  {
    question: "Does this tool work on mobile devices?",
    ans: "Yes, our URL conversion is optimized for mobile and desktop browsers, ensuring seamless use on any device.",
  },
];

export default URLDecoderFaqData;
